/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}      from '@/models/action';
import {Logger}                  from '@/util/logger';
import {WindowService}           from "@/services/window.service";
import {DiversionEditorMetadata} from '@/screens/ide/diversion.editor.metadata'

/**
 *
 * @class DiversionEditAction
 *
 * @brief launch a new / blank diversions editor
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class DiversionEditAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.diversioneditor',
      type:  ActionType.Window_Diversion,
      label: 'Diversion Editor (Empty)',
      icon:  '<i class="fas fa-route"></i>',
      tip:   'Launch a diversion editor'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[DiversionEditAction] executing...');

    this.windows.launchWindow(new DiversionEditorMetadata(
      '',
      '',
      ''
    ));

    return true;
  }
}
